import VizRenderer from '../../../../genui/VizRenderer';
import { VizBlock } from '../../../../genui/viz.types';

interface RachelVizPartProps {
  blocks: VizBlock[];
}

const RachelVizPart = ({ blocks }: RachelVizPartProps) => {
  return (
    <>
      {blocks.map((block, index) => (
        <VizRenderer key={index} block={block} />
      ))}
    </>
  );
};

export default RachelVizPart;
